import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// import { ClerkProvider } from '@clerk/clerk-react';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';

// const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <ClerkProvider publishableKey={clerkPubKey}> */}
      <App />
    {/* </ClerkProvider> */}
  </React.StrictMode>
);

reportWebVitals();
